
















export default {
  name: 'RadioButton'
  props: [
    'id'
    'label'
    'name'
    'val'
    'value'
    'validate'
  ]
  mounted: () ->
    componentHandler.upgradeElements @$el

  methods:
    onChange: (event) ->
      @$emit 'input', event.target.value
      if @errors.any()
        @$emit 'errors', @errors.all()

  watch:
    value: (val) ->
      @$validator.validateAll()
      .then (result)->
        console.log  result
      .catch (err) ->
        console.log  er
  
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/RadioButton.vue